<app-headerpicture></app-headerpicture>

<div class="vl-region">
  <div class="vl-layout vl-layout--wide">
    <div class="vl-grid vl-grid--is-stacked">
      <div class="vl-col--9-12 vl-col--9-12--m vl-col--12-12--s vl-col--1-1--xs">
        <app-title title="{{ 'PROJECT_TITEL' | translate }}" subTitle="{{ 'OVERZICHT.SUB_TITEL' | translate }}"> </app-title>

        <!-- Begin NIJB  -->
        <section class="vl-infoblock">
          <div>
            <div class="vl-u-spacer--large" [innerHtml]="'OVERZICHT.SUB_TEXT' | translate"></div>

            <section>
              <div class="vl-grid vl-u-spacer--large">
                <div class="vl-col--12-12" *ngIf="isIndieningActief$ | async">
                  <button class="vl-button vl-u-float-right" (click)="startAanvraag()">Nieuwe aanvraag</button>
                </div>
              </div>
            </section>

            <section>
              <div class="vl-u-spacer">
                <h3 class="vl-title vl-title--h3 vl-title--sans">Mijn aanvragen</h3>
              </div>
              <app-aanvraag-overzicht
                [aanvragenOverzicht]="aanvragenOverzicht$ | async"
                (onOpenDetail)="openDetail($event)"
                (onDelete)="deleteAanvraag($event)"
              ></app-aanvraag-overzicht>
            </section>
          </div>
        </section>
        <!-- End NIJB  -->

        <!-- Begin content -->

        <!-- End content -->
      </div>
      <div class="vl-col--3-12 vl-col--3-12--m vl-col--12-12--s vl-col--1-1--xs">
        <!-- Begin Side navigation -->

        <!-- End Side navigation -->
      </div>
    </div>
  </div>
</div>
